import { useLocation, useNavigate } from 'react-router-dom';
import { useAdmin } from '../../hooks/use-admin-context';
import { useCallback, useEffect, useRef, useState } from 'react';
import './legacy-view.scss';
import { Spinner } from '../spinner/spinner';
import axios from 'axios';

export const LegacyView = () => {
  const { contextPath } = useAdmin();
  const location = useLocation();
  const navigate = useNavigate();
  const iframeRef = useRef<HTMLIFrameElement>(null);

  const legacyPath = contextPath === '' ? location.pathname : location.pathname.replace(contextPath, '/');
  const newUrl = `${contextPath ? contextPath : '/'}legacy-app${legacyPath}${location.search && `${location.search}`}`;

  const [isLoading, setIsLoading] = useState<boolean>(true);

  function onLoad() {
    const documentIFrame = iframeRef.current?.contentDocument;
    const windowIFrame = iframeRef.current?.contentWindow;

    // Force to have legacy-app in the iframe
    if (windowIFrame && !windowIFrame?.location.pathname.includes('legacy-app')) {
      const addLegacy = `${contextPath ? contextPath : '/'}legacy-app${legacyPath}${
        windowIFrame.location.search && `?${windowIFrame.location.search}`
      }`;

      windowIFrame.location.pathname = addLegacy;
    }

    const getFullUrl = function (window: Window) {
      let legacyPath =
        contextPath === '/' ? window.location.pathname : window.location.pathname.replace(contextPath, '/');

      if (legacyPath.includes('legacy-app')) {
        legacyPath = legacyPath.replace('legacy-app/', '');
      }

      return `${contextPath ? contextPath : '/'}legacy-app${legacyPath}${
        window.location.search && `?${window.location.search}`
      }`;
    };

    if (windowIFrame?.location && (getFullUrl(windowIFrame) != newUrl || getFullUrl(window) != newUrl)) {
      window.history.pushState({}, '', windowIFrame?.location.href.replace('/legacy-app', ''));
      // Make react router listen url change
      const navEvent = new PopStateEvent('popstate');
      window.dispatchEvent(navEvent);
    }

    setIsLoading(false);

    const body = documentIFrame?.getElementById('body');

    body?.addEventListener('components-loaded', updateContentForSPAMode);
    body && (body.scrollTop = 0);
    updateLeftNav();
    updateContentForSPAMode();
  }

  const closeDropdownEvent = useCallback(() => {
    document.body.dispatchEvent(new CustomEvent('close-dropdown'));
  }, []);

  const updateLeftNav = useCallback(() => {
    document.body.dispatchEvent(new CustomEvent('update-left-nav'));
  }, []);

  const updateContentForSPAMode = useCallback(
    () =>
      setTimeout(() => {
        const documentIFrame = iframeRef.current?.contentDocument;
        const windowIFrame = iframeRef.current?.contentWindow;

        const body = documentIFrame?.getElementById('body');

        if (documentIFrame?.getElementById('frmLogin')) {
          const params = new URLSearchParams();
          params.set('dest', window.location.pathname + window.location.search);
          window.location.pathname = `${contextPath ? `/${contextPath}` : ''}/manager/admin/login`;
          window.location.search = params.toString();
        }

        if (body) {
          const anchorTags = body.getElementsByTagName('a');

          if (anchorTags) {
            for (let i = 0; i < anchorTags.length || 0; ++i) {
              const a = anchorTags[i];
              const href = a.getAttribute('href');
              const isBlank = a.getAttribute('target') === '_blank';

              if (!href || href.indexOf('javascript') >= 0) {
                a.removeAttribute('href');
              } else if (href && a && !href.startsWith('#') && !href.startsWith('tel')) {
                a.onclick = function (e) {
                  e.preventDefault();

                  if (isBlank) {
                    window.open(href, '_blank');
                    return;
                  }

                  axios
                    .get(href)
                    .then((response) => {
                      const url = new URL(response.request.responseURL);
                      const anchorUrl = url.pathname.replace('/legacy-app/', '/');

                      if (location.pathname === anchorUrl && windowIFrame?.location) {
                        windowIFrame.location.pathname = url.pathname;
                      } else {
                        navigate(anchorUrl);
                      }
                    })
                    .catch((response) => {
                      const url = new URL(response.request.responseURL);
                      const anchorUrl = url.pathname.replace('/legacy-app/', '/');

                      if (location.pathname === anchorUrl && windowIFrame?.location) {
                        windowIFrame.location.pathname = url.pathname;
                      } else {
                        navigate(anchorUrl);
                      }
                    });
                };
              }
            }
          }

          body?.removeEventListener('click', closeDropdownEvent);
          body?.addEventListener('click', closeDropdownEvent);
        }
        document.body.dispatchEvent(new Event('init-components'));
      }, 400),
    [iframeRef.current, location],
  );

  // TODO: remove this when order list (or any list 2.0 inside an iframe) is removed
  useEffect(() => {
    const loadLegacyParams = (event: MessageEvent) => {
      if (event.data && event.data.type === 'legacy-view' && event.data.action === 'updateSearchParams') {
        window.history.pushState(
          'updateSearchParams',
          '',
          `${window.location.origin}${window.location.pathname}?${new URLSearchParams(event.data.data).toString()}`,
        );
      }
    };
    window.addEventListener('message', loadLegacyParams);

    return () => {
      window.removeEventListener('message', loadLegacyParams);
    };
  }, []);

  return (
    <div className="legacy-view h-full">
      {isLoading && <Spinner />}
      <iframe
        hidden={isLoading}
        id="legacy-view-container"
        className="legacy-container h-full"
        src={newUrl}
        onLoad={onLoad}
        ref={iframeRef}
      />
    </div>
  );
};
